import { AvailableRegions, DEFAULT_REGION, REGION_KEY } from './constants';
var getIsRegion = function getIsRegion(value) {
    return Object.values(AvailableRegions).includes(value);
};
var getStoredRegion = function getStoredRegion() {
    var storedValue = sessionStorage.getItem(REGION_KEY);
    return getIsRegion(storedValue) ? storedValue : DEFAULT_REGION;
};
export var setStoredRegion = function setStoredRegion(region) {
    sessionStorage.setItem(REGION_KEY, region);
};
export var resolveRegion = function resolveRegion(queryParamValue) {
    return getIsRegion(queryParamValue) ? queryParamValue : getStoredRegion();
};
